import {ClickEvent} from "../../../infrastructure/models/analytics/click-event";
import {ANALYTICS} from "../../../third-party-services/analytics/analytics-consts";

export class H2hClickEvent extends ClickEvent {
  gameId: Number;
  status: Number;
  source: String;
  sportTypeId: Number;

  constructor(params) {
    super('', 'click', 'h2h');

    this.gameId = params.gameId;
    this.status = params.status;
    this.source = params.source;
    this.sportTypeId = params.sportTypeId;
  }

  get properties() {
    const properties = super.properties;

    properties.gameId = this.gameId;
    properties.status = ANALYTICS.GAME_STATUSES[this.status];
    properties.source = this.source;
    properties.sportTypeId = this.sportTypeId;

    return properties;
  }
}
